import React from 'react';
import { KeenIcon } from '@/components';

const Header = ({ type = 'reference-data', onClose }) => (
  <div className="flex items-center justify-between border-b px-6 py-3">
    <h2 className="text-lg font-bold">Manage {type === 'reference-data' ? 'Reference Data' : 'Suggested'}</h2>
    <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
      <KeenIcon icon="cross" />
    </button>
  </div>
);

export { Header }; 